import { gql } from '@apollo/client';

/**
 * ТЗ 0114 (#158) — записи реквизитов преподавателя и финансовых условий
 * заявки (узкая мутация, не вся заявка). Имена операций ≠ полям бэкенда.
 */

export const CreateTeacherBillingEntityMutation = gql`
  mutation AddTeacherBillingEntity(
    $teacherId: ID!
    $input: TeacherBillingEntityInput!
  ) {
    createTeacherBillingEntity(teacherId: $teacherId, input: $input) {
      success
      customErrors {
        field
        code
        message
      }
      billingEntity {
        id
        teacherId
        kind
        legalName
        nip
        vatMode
        vatRate
        isDefault
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const UpdateTeacherBillingEntityMutation = gql`
  mutation EditTeacherBillingEntity(
    $id: ID!
    $input: TeacherBillingEntityInput!
  ) {
    updateTeacherBillingEntity(id: $id, input: $input) {
      success
      customErrors {
        field
        code
        message
      }
      billingEntity {
        id
        teacherId
        kind
        legalName
        nip
        vatMode
        vatRate
        isDefault
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;

export const SetDefaultTeacherBillingEntityMutation = gql`
  mutation MakeDefaultTeacherBillingEntity($id: ID!) {
    setDefaultTeacherBillingEntity(id: $id) {
      success
      customErrors {
        field
        code
        message
      }
      billingEntity {
        id
        isDefault
      }
    }
  }
`;

export const SetApplicationFinanceTermsMutation = gql`
  mutation StoreApplicationFinanceTerms(
    $applicationId: ID!
    $rateUnit: String
    $rateIsGross: Boolean
    $billingEntityId: ID
    $clearBillingEntity: Boolean
    $servicePrice: Float
    $currency: String
  ) {
    setApplicationFinanceTerms(
      applicationId: $applicationId
      rateUnit: $rateUnit
      rateIsGross: $rateIsGross
      billingEntityId: $billingEntityId
      clearBillingEntity: $clearBillingEntity
      servicePrice: $servicePrice
      currency: $currency
    ) {
      success
      customErrors {
        field
        code
        message
      }
      application {
        id
        servicePrice
        currency
        rateUnit
        rateIsGross
        termsMissing
        billingEntity {
          id
          teacherId
          kind
          legalName
          nip
          vatMode
          vatRate
          isDefault
          isActive
          createdAt
          updatedAt
        }
      }
    }
  }
`;
